import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";



function Banner(props) {
    return (
        <div className="services_banner lp-banner" >
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Ai Service">
                                <h1>Elevate Your Business with AI as a Service (AIaaS)</h1>
                            </div>
                            <p className="main_para">Experience the future of AI with our revolutionary AI as a Service (AIaaS) offering. Discover on-demand AI solutions that allow your business to flourish in the era of intelligence. Embrace innovation today and stay ahead of the competition.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto ms-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;